// extracted by mini-css-extract-plugin
module.exports = {"tagTitle":"tags-module--tag--title--1LVCn","tagLink":"tags-module--tag--link--3PGEv"};